import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react'
import { moreFromGodrejAPI } from '../../../../public/constants/constants';
import apiManager from '../../../utils/apiManager';
import "../../../../public/styles/blog/moreFromGI.scss";
import BlogCard from '../blogCard';

function MoreFromGodrej() {

  const [postData, setPostDta] = useState([])

  useEffect(() => {
    moreFromGodrej();
  }, [])

  const moreTitle = "More from Godrej Interio";
  const moreFromGodrej = () => {
    apiManager
      .get(moreFromGodrejAPI)
      .then(response => {
        const data = response.data.data.slice(1);
        setPostDta(data);
      })
      .catch(error => {
        console.log("trendingBlogs", error);
      });
  };

  return (
    <div className="more-from-godrej-section">
      {postData.length>0 && <div className="more-title">
        {moreTitle}
      </div>}

      <div className="more-from-godrej">
        {postData && postData.map(blog => (
          <BlogCard blog={blog} isFromMoreFromGI/>
        ))}
      </div>
    </div>
  )
}

export default MoreFromGodrej
